import { ContentfulImage } from '@ecomm/contentful/components'

import classNames from 'classnames'
import { match } from 'ts-pattern'

export const FREE_CAMERA_BANNER_GET_COPY =
  'Get a FREE Outdoor Camera with Pro or Pro Plus*'
export const FREE_CAMERA_BANNER_CHANGE_COPY =
  'Change plan to Pro or Pro Plus to get a FREE Outdoor Camera'
export const FREE_CAMERA_BADGE_COPY = 'Includes FREE Outdoor Camera'

type Props = {
  readonly bannerStyle:
    | 'badge-image'
    | 'badge-text'
    | 'banner-change'
    | 'banner-get'
}

export function FreeCameraBanner({ bannerStyle }: Props) {
  const isBadge = bannerStyle === 'badge-image' || bannerStyle === 'badge-text'
  const shouldShowCamera = bannerStyle !== 'badge-text'
  const copy = match(bannerStyle)
    .with('banner-get', () => FREE_CAMERA_BANNER_GET_COPY)
    .with('banner-change', () => FREE_CAMERA_BANNER_CHANGE_COPY)
    .with('badge-image', () => FREE_CAMERA_BADGE_COPY)
    .with('badge-text', () => FREE_CAMERA_BADGE_COPY)
    .exhaustive()

  return (
    <div
      className={classNames(
        'bg-[#DEF2ED] text-complementary-green-100 font-bold rounded-[20px] py-1 justify-center flex flex-row',
        {
          'min-h-[44px]': shouldShowCamera,
          'p-4': !isBadge,
          'mx-4': isBadge
        }
      )}
    >
      {shouldShowCamera ? (
        <ContentfulImage
          classNameOverride="w-[44px] h-[44px] align-middle"
          description="Outdoor Camera"
          loading="normal"
          originalHeight={320}
          originalWidth={320}
          quality={90}
          url={
            'https://images.ctfassets.net/v6awd0kabi65/14iuCWv1FtQETPOw6R77jc/fe2191815e835277cd6eb2a1e294d052/image__6_.png'
          }
        />
      ) : null}
      <span
        className={classNames('content-center ', {
          'pl-1': shouldShowCamera,
          'text-sm/[18px] md:text-base text-left md:text-center': !isBadge,
          'text-[10px] text-center': bannerStyle === 'badge-text',
          'text-lg text-center': bannerStyle === 'badge-image'
        })}
      >
        {copy}
      </span>
    </div>
  )
}
